<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Anak Perusahaan</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_logo != null ? 'Edit' : 'Tambah' }} Slider
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">Tipe</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <select v-model="data.tipe" class="form-control">
                                                <option value="">[ Pilih Tipe ]</option>
                                                <option value="1">Company Link</option>
                                                <option value="2">Anak Perusahaan</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="icon">Gambar</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <img v-if="data.gambar != null" v-bind:src="data.gambar" width="150px" alt="Foto" />
                                        <div class="form-group">
                                            <input id="icon" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="text1">Link</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="text1" type="text" v-model="data.link"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                      <label for="text1">Description</label>
                                  </div>
                                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                      <div class="form-group">
                                          <form-line id="text1" type="text" v-model="data.description"></form-line>
                                      </div>
                                  </div>
                              </div>
                                <div class="row clearfix">
                                  <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                      <label for="text1">Name</label>
                                  </div>
                                  <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                      <div class="form-group">
                                          <form-line id="text1" type="text" v-model="data.name"></form-line>
                                      </div>
                                  </div>
                              </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" v-if="id_logo != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger waves-effect waves-button" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'FormAnakPerusahaan',
    data: function () {
      return {
        data: {
          link: '',
          tipe: '',
          description:'',
          name:''
        },
        gambar: '',
        id_logo: '',
        isLoading: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.data))
        api.post('/anak-perusahaan', form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/anak-perusahaan')
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.data))
        api.post('/anak-perusahaan/' + this.id_logo, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/anak-perusahaan')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/anak-perusahaan/' + this.id_logo).then((result) => {
          this.data = result.data
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      handleFile (file) {
        this.file = file.target.files[0]
      }
    },
    mounted () {
      this.id_logo = this.$route.params.id
      if (this.id_logo != null) {
        this.getDetail()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/FormAnakPerusahaan.vue?1334a9f9